<h1>Freigaben</h1>

<!-- Start -->
<h2>Freigabe für Vermittler</h2>

@if (!alreadyHasMakler) {
    <elem-msg-line [notification]="messageLineMakler"></elem-msg-line>
}

<!-- 1. Schritt -->
@if (initialized && vermittlerStep === 1) {
    <div class="gridContainer fitGrid">
        <div class="row">
            <div class="cell grid-50 alignr">
                <label for="f_code_vermittler">Bitte Vermittler-Portal-Nummer eingeben:</label>
            </div>
            <div class="cell grid-25">
                <input type="text"
                       id="f_code_vermittler"
                       name="f_code_vermittler"
                       placeholder="Form: nnnnnnnnn"
                       value=""
                       [(ngModel)]="model.maklerId.value"
                       [class.error]="model.maklerId.valid===false"
                       (blur)="validateField(model.maklerId)">
                @if (model.maklerId.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.maklerId.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
                <button class="btn-orange" (click)="setVermittlerNumber(2)">
                    Weiter
                </button>
            </div>
        </div>
    </div>
}

<!-- 2. Schritt (wenn die Eingabe eines Vermittlernr.s zum Erfolg geführt hat) -->
@if (initialized && vermittlerStep === 2) {
    <div class="gridContainer fitGrid">
        @if (!alreadyHasMakler) {
            <div class="row trenner"></div>
        }
        <div class="row">
            <div class="cell grid-100">
                <input type="checkbox"
                       name="f_bestaetigung_freigabe_vermittler"
                       id="f_bestaetigung_freigabe_vermittler"
                       [(ngModel)]="vermittlerChecked"/>
                <label for="f_bestaetigung_freigabe_vermittler">
                    <span>
                        Mit Setzen des Häkchens und anschließender Bestätigung erkläre ich mich damit einverstanden, dass mein für das
                        Kreditportal registrierter Vermittler, <strong>Vermittlernr. {{ model.maklerId.value }}</strong>, Zugang zu sämtlichen meiner
                        Daten erhält und in meinem Namen alle Funktionalitäten des Kreditportals nutzen darf. Dieses Einverständnis kann ich jederzeit durch
                        Entfernen des Häkchens und anschließende Bestätigung widerrufen.
                    </span>
                </label>
            </div>
        </div>
        <!-- Freigabe erteilen -->
        @if (!alreadyHasMakler) {
            <div>
                <div class="row trenner"></div>
                <div class="row">
                    <div class="cell grid-25">
                        @if (!alreadyHasMakler) {
                            <button
                                class="btn-grau"
                                (click)="setVermittlerNumber(1)">
                                Abbrechen
                            </button>
                        }
                    </div>
                    <div class="cell grid-50">
                    </div>
                    <div class="cell grid-25">
                        @if (!alreadyHasMakler && vermittlerChecked) {
                            <button
                                class="btn-orange"
                                (click)="hireOrFireVermittler()">
                                Freigabe erteilen
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
        <!-- Freigabe entziehen -->
        @if (alreadyHasMakler && !vermittlerChecked) {
            <div>
                <div class="row trenner"></div>
                <div class="row">
                    <div class="cell grid-75">
                    </div>
                    <div class="cell grid-25">
                        @if (alreadyHasMakler && !vermittlerChecked) {
                            <button
                                class="btn-orange"
                                (click)="hireOrFireVermittler(true)">
                                Freigabe entziehen
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}

<!-- Start -->
<h2>
    Freigabe für Steuerberater
</h2>
@if (!alreadyHasStbr) {
    <elem-msg-line [notification]="notificationStbr"></elem-msg-line>
}

@if (initialized && steuerberaterStep === 1) {
    <div class="gridContainer fitGrid">
        <div class="row">
            <div class="cell grid-50 alignr">
                <label for="f_code_vermittler_2">Bitte Steuerberater-Portal-Nummer eingeben:</label>
            </div>
            <div class="cell grid-25">
                <input type="text"
                       id="f_code_vermittler_2"
                       name="f_code_vermittler"
                       placeholder="Form: 023nnnnnnnnnn"
                       value=""
                       [(ngModel)]="model.steuerberater.value"
                       [class.error]="model.steuerberater.valid === false"
                       (blur)="validateField(model.steuerberater)">
                @if (model.steuerberater.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.steuerberater.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25">
                <button class="btn-orange" (click)="setSteuerberaterNumber(2)">
                    Weiter
                </button>
            </div>
        </div>
    </div>
}

@if (initialized && steuerberaterStep === 2) {
    <div class="gridContainer fitGrid">
        <div class="row">
            <div class="cell grid-100">
                <input type="checkbox"
                       name="f_bestaetigung_freigabe_vermittlerX"
                       id="f_bestaetigung_freigabe_vermittlerX"
                       [(ngModel)]="steuerberaterChecked">
                <label for="f_bestaetigung_freigabe_vermittlerX">
                  <span>Mit Setzen des Häkchens und anschließender Bestätigung erkläre ich mich damit einverstanden, dass mein für das
                    Kreditportal registrierter Steuerberater, <strong>Steuerberaternr. {{ model.steuerberater.value }}</strong>, Zugang zu sämtlichen
                    meiner Daten erhält und in meinem Namen meinen Jahresabschluss hochladen und eine Obligoliste anfordern darf.
                  Dieses Einverständnis kann ich jederzeit durch Entfernen des Häkchens und anschließende Bestätigung widerrufen.</span>
                </label>
            </div>
        </div>
        <!-- Freigabe erteilen -->
        @if (!alreadyHasStbr) {
            <div>
                <div class="row trenner"></div>
                <div class="row">
                    <div class="cell grid-25">
                        @if (!alreadyHasStbr) {
                            <button class="btn-grau" (click)="setSteuerberaterNumber(1)">
                                Abbrechen
                            </button>
                        }
                    </div>
                    <div class="cell grid-50">
                    </div>
                    <div class="cell grid-25">
                        @if (!alreadyHasStbr && steuerberaterChecked) {
                            <button
                                class="btn-orange"
                                (click)="hireOrFireSteuerberater()">
                                Freigabe erteilen
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
        <!-- Freigabe entziehen -->
        @if (alreadyHasStbr && !steuerberaterChecked) {
            <div>
                <div class="row trenner"></div>
                <div class="row">
                    <div class="cell grid-75">
                    </div>
                    <div class="cell grid-25">
                        @if (alreadyHasStbr && !steuerberaterChecked) {
                            <button
                                class="btn-orange"
                                (click)="hireOrFireSteuerberater(true)">
                                Freigabe entziehen
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}
